import {
  Paper,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import {
  capitalize,
  Loader,
  Pagination,
  PaginationWithoutParams,
  pluralize,
  TableTitle,
} from '@shared';
import * as S from './SimpleTable.styled';
import { SimpleTablePropsType } from './SimpleTable.types';

export const SimpleTable = <T extends { uuid: string }, ColumnsIds>(
  props: SimpleTablePropsType<T, ColumnsIds>
) => {
  const {
    onRowClick,
    rows,
    isLoading,
    entityName,
    renderElems,
    pagination,
    totalPages,
    onPageChange,
    noBorders = false,
    noParams,
    page,
  } = props;

  return (
    <S.TableContainer component={Paper} noBorders={noBorders}>
      <MuiTable>
        <TableHead sx={{ display: entityName ? 'table-header-group' : 'none' }}>
          {props.columns ? (
            <TableRow>
              {props.columns.map((headCell, i) => (
                <S.TableTitleCell key={i}>
                  <Typography>{headCell.label}</Typography>
                </S.TableTitleCell>
              ))}
            </TableRow>
          ) : (
            <TableTitle entityName={entityName} />
          )}
        </TableHead>
        <TableBody>
          {rows.length ? (
            rows.map((row) => (
              <S.TableRow
                noBorders={noBorders}
                sx={{ cursor: props.columns ? 'auto' : 'pointer' }}
                hover={!props.columns}
                key={row.uuid}
                onClick={() => onRowClick && onRowClick({ [entityName]: row.uuid })}
                data-testid={`${entityName}-table-row`}
              >
                {props.columns ? renderElems(row) : <S.TableCell>{renderElems(row)}</S.TableCell>}
              </S.TableRow>
            ))
          ) : (
            <S.TableRow data-testid={`${entityName}-empty-table-row`}>
              <TableCell colSpan={props.columns?.length} sx={{ textAlign: 'center' }}>
                <i>No {pluralize(capitalize(entityName))} Found</i>
              </TableCell>
            </S.TableRow>
          )}
        </TableBody>
        {pagination && (
          <TableFooter>
            <S.TableRow>
              <S.FooterCell colSpan={props.columns?.length}>
                {noParams && page ? (
                  <PaginationWithoutParams
                    page={page}
                    totalPages={totalPages}
                    onPageChange={onPageChange}
                  />
                ) : (
                  <Pagination totalPages={totalPages} onPageChange={onPageChange} />
                )}
              </S.FooterCell>
            </S.TableRow>
          </TableFooter>
        )}
      </MuiTable>
      {isLoading && <Loader />}
    </S.TableContainer>
  );
};
